import { Navigate, RouteObject } from 'react-router';
import ControlModesList from '@src/components/Home/Config-Beta/Modes/ControlModesList';
import StacksList from '@src/components/Home/Config-Beta/Stacks/StacksList';
import AppLayout from '@src/pages/_layout/AppLayout';
import TopBar from './TopBar';
import CalendarView from '@src/components/Home/Config-Beta/Calendar/CalendarView';
import ConfigBetaGuard from './ConfigBetaGuard';

export default [
  {
    element: (
      <ConfigBetaGuard>
        <AppLayout isNested topBar={<TopBar />} />
      </ConfigBetaGuard>
    ),
    children: [
      {
        path: 'config-beta',
        children: [
          { index: true, element: <Navigate to='modes' replace /> },
          { path: 'stacks', element: <StacksList /> },
          { path: 'modes', element: <ControlModesList /> },
          { path: 'calendar', element: <CalendarView /> },
        ],
      },
    ],
  },
] as RouteObject[];
